import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { deployUrl, provideSentry } from '@thiememeulenhoff/ng-sdk';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { authInterceptor } from '../_interceptors/auth.interceptor';
import { apiInterceptor } from '../_interceptors/api.interceptor';
import { unauthorizedInterceptor } from '../_interceptors/unauthorized.interceptor';
import { provideAppBootstrap } from '../_providers/app-bootstrap.initializer';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideSentry,
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        apiInterceptor,
        unauthorizedInterceptor,
      ]),
    ),
    provideBrowserGlobalErrorListeners(),
    provideOAuthClient(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAppBootstrap(),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => `${deployUrl()}${config.src}`,
    },
  ],
};
